angular.module('core')
    .component('copyToClipboard', {
        bindings: {
            value: '<'
        },
        template: '<span class="copyToClipboard" uib-tooltip="Skopiuj do schowka" ng-click="$ctrl.copyToClipboard()"><i class="fa fa-fw fa-clipboard"></i></span>',
        controller: function (ngClipboard, toastr) {
            this.copyToClipboard = () => {
                ngClipboard.toClipboard(this.value);
                toastr.success("Skopiowano do schowka");
            }
        }
    })
